import { FC } from 'react';
import Svg, { SvgProps } from '@/components/shared/Svg/Svg.tsx';

const ChevronRightIcon: FC<Omit<SvgProps, 'children'>> = (props) => {
  return (
    <Svg viewBox="0 0 8 12" {...props}>
      <path d="M1.41 0L0 1.41L4.58 6L0 10.59L1.41 12L7.41 6L1.41 0Z" fill="currentColor" />
    </Svg>
  );
};

export default ChevronRightIcon;
